<ng-container>
  <form [formGroup]="zakelijkePartnersFg">
    <ng-container formArrayName="zakelijkePartners">
      @for (item of zakelijkePartners.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row">
            <div class="row align-items-center">
              <div class="col-auto">
                <h6>{{ displayNameZakelijkPartner(i) }}</h6>
              </div>
              <div class="col-auto mb-1">
                <snelstart-ui-button
                  (click)="onDelete(i)"
                  icon="trash"
                  iconType="light"
                  id="buttonDelete"
                  size="medium"
                  type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
            <hr>
            <ng-container formGroupName="identificationNumberTypedMember">
              <snelstart-ui-text-form-control formControlName="value"
                                              label="Identificatienummer"
                                              id="identificationNumberTypedMember"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="this.saveForm(true)"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="prefix">
              <snelstart-ui-text-form-control formControlName="value"
                                              label="Voorvoegsel"
                                              id="prefix"
                                              class="me-1 custom-input-200"
                                              (change)="this.saveForm(true)">
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="familyName">
              <snelstart-ui-text-form-control formControlName="value"
                                              label="Geslachtsnaam"
                                              id="familyName"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="saveForm(true)"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="firstName">
              <snelstart-ui-text-form-control formControlName="value"
                                              label="Voornamen"
                                              id="firstName"
                                              class="me-1 custom-input-200"
                                              (change)="this.saveForm(true)"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="dateOfBirth">
              <snelstart-ui-date-form-control formControlName="value"
                                              label="Geboortedatum"
                                              id="dateOfBirth"
                                              [required]=true
                                              class="me-1 custom-input-200"
                                              (change)="this.saveForm(true)"
              >
              </snelstart-ui-date-form-control>
            </ng-container>
          </div>
          <div class="row">
            <div class="col col-1 bold"></div>
            <div class="col-2"></div>
            <div class="col-3 bold">
              Huidige periode
            </div>
<!--            <div class="col-4 bold">-->
<!--              Vorige periode-->
<!--            </div>-->
          </div>
          <div class="pt-1"></div>
          <ng-container formGroupName="eigenVermogenNatuurlijkPersoonMutatieoverzicht">
            <ng-container formGroupName="shareInResultPercentage">
              <div class="row">
                <div class="col col-1">
                  <p style="padding: 6px">Aandeel in het resultaat: percentage</p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    prefix="%"
                                                    [showAllDecimals]="true"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
<!--                <div class="col-4">-->
<!--                  <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                                    class="custom-input-150 custom-readonly"-->
<!--                                                    align="right"-->
<!--                                                    prefix="%"-->
<!--                                                    [showAllDecimals]="true"-->
<!--                                                    [disabledControl]="true"-->
<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                </div>-->
              </div>
            </ng-container>
            <ng-container formGroupName="interestOnCapitalPercentage">
              <div class="row">
                <div class="col col-1">
                  <p style="padding: 6px">Rente op kapitaal: percentage</p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    prefix="%"
                                                    [showAllDecimals]="true"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
<!--                <div class="col-4">-->
<!--                  <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                                    class="custom-input-150 custom-readonly"-->
<!--                                                    align="right"-->
<!--                                                    prefix="%"-->
<!--                                                    [showAllDecimals]="true"-->
<!--                                                    [disabledControl]="true"-->
<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                </div>-->
              </div>
            </ng-container>
            <ng-container formGroupName="remunerationAllowance">
              <div class="row">
                <div class="col col-1">
                  <p style="padding: 6px">Arbeidsvergoeding</p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    prefix="€"
                                                    [showAllDecimals]="false"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
<!--                <div class="col-4">-->
<!--                  <snelstart-ui-number-form-control formControlName="valuePeriod2"-->
<!--                                                    class="custom-input-150 custom-readonly"-->
<!--                                                    align="right"-->
<!--                                                    prefix="€"-->
<!--                                                    [showAllDecimals]="false"-->
<!--                                                    [disabledControl]="true"-->
<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                </div>-->
              </div>
            </ng-container>
          </ng-container>
          <div class="pt-2"></div>
        </ng-container>
      }
    </ng-container>

    <div>
      <snelstart-ui-dialog-definition id="deleteDialog"
                                      title="Verwijderen zakelijke partner"
                                      size="lg"
                                      [(visible)]="deleteDialogVisible">
        <snelstart-ui-dialog-body>
          <div class="ps-1">
            <p>
              Weet je zeker dat je {{ displayNameZakelijkPartnerPendingDelete }} wilt verwijderen?
            </p>
          </div>

          <div class="ps-1">
            <p class="mb-2">
              <strong>Let op:</strong> het verwijderen van een zakelijke partner met een aandeel in het resultaat,
              arbeidsvergoeding en/of rente op kapitaal
              heeft invloed op het totale resultaat dat wordt verwerkt binnen de mutatieoverzichten van het eigen
              vermogen van de zakelijke partner(s).
            </p>
            <ul>
              <li>
                Zorg er sowieso voor dat het totaal van 'Aandeel in het resultaat: percentage', altijd 100% is.
              </li>
              <br/>
              <li>
                Rente op kapitaal wordt altijd berekend o.b.v. de beginstand van het eigen vermogen in het
                mutatieoverzicht van de betreffende zakelijke partner.
              </li>
              <br/>
              <li>
                Afhankelijk van de ingevulde gegevens worden de berekende waarden van aandeel in het resultaat,
                arbeidsvergoeding en rente op kapitaal automatisch gegenereerd en inzichtelijke gemaakt op de post
                'Aandeel in het resultaat' in het mutatieoverzicht van de betreffende zakelijke partner.
              </li>
            </ul>
          </div>
        </snelstart-ui-dialog-body>

        <snelstart-ui-dialog-buttons class="d-flex mt-2">
          <snelstart-ui-button type="secondary" icon="xmark" btn-x
                               (click)="cancelDelete()">Nee, annuleren
          </snelstart-ui-button>

          <snelstart-ui-button class="ps-3" type="primary" icon="check"
                               (click)="confirmDelete()">Ja, bevestigen
          </snelstart-ui-button>
        </snelstart-ui-dialog-buttons>
      </snelstart-ui-dialog-definition>
    </div>

    @if (!this.isEenmanszaak || ((zakelijkePartners ? zakelijkePartners.length : 0) < 1)) {
      <div>
        <snelstart-ui-button id="addO" class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRow()">Item toevoegen
        </snelstart-ui-button>
      </div>
    }
  </form>

</ng-container>


